import React from "react";
import Reminder from "../common/Reminder";
import Sidebar from "./Sidebar";
import { handleModalNoticeOverlay, toggleSidebar } from "../common/utils/common";
import Cookies from "universal-cookie";
import ModalNoticeOverlay from "../common/ModalNoticeOverlay";

class App extends React.Component {
  render() {
    return (
      <div>
        <ModalNoticeOverlay />
        <div
          id="site-wrapper"
          className="theme-a"
          onClick={(event) => handleModalNoticeOverlay(event)}
        >
          <header class="site-header">
            <div class="site-header-container">
              <div class="site-header-row">
                <div class="header-tagline">
                  <a
                    id="headerimage"
                    href="https://www.immigrationdirect.com/"
                    class="site-logo"
                  >
                    <img
                      src="/assets-static/images/logo-en.png"
                      alt="Immigration Direct"
                      title="Immigration Direct"
                    />
                  </a>
                </div>
                <div class="m-menu-icon">
                  <button onClick={() => toggleSidebar()} class="menu-icon">
                    <span class="menu-icon-bar"></span>
                    <span class="menu-icon-bar"></span>
                    <span class="menu-icon-bar"></span>
                  </button>
                </div>
                <div class="user-utility user-utility-padding">
                  <div class="user-auth">
                    <div class="button">
                      <a
                        id="header-signin"
                        href="/registration/logincheck.do?next=/application-center/applicationcenter.do&amp;lang=en"
                        class="btn-header"
                      >
                        My Account
                      </a>
                      <a
                        id="header-signout"
                        style={{ display: "none" }}
                        href="/application-center/signout.do"
                        class="btn-header"
                      >
                        Sign Out
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>

          <nav className="site-nav">
            <div className="site-nav-container">
              {/* Citizenship Forms */}
              <div className="nav-item">
                <a href="#">Citizenship Forms</a>
                <div className="menu-row">
                  <ul>
                    <li>
                      <a href="https://www.immigrationdirect.com/us-citizenship-n400-preparation-service/">
                        U.S. Citizenship (N-400)
                      </a>
                    </li>
                    <li>
                      <a href="https://www.immigrationdirect.com/citizenship-certificate-n600-preparation-service/">
                        Citizenship Certificate (N-600)
                      </a>
                    </li>
                    <li>
                      <a href="https://www.immigrationdirect.com/replace-citizenship-certificate-n565-preparation-service/">
                        Renew Citizenship Certificate (N-565)
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Green Card Forms */}
              <div className="nav-item">
                <a href="#">Green Card Forms</a>
                <div className="menu-row">
                  <ul>
                    <li>
                      <a href="https://www.immigrationdirect.com/green-card-renewal-i90-preparation-service/">
                        Green Card Renewal (I-90)
                      </a>
                    </li>
                    <li>
                      <a href="https://www.immigrationdirect.com/petition-for-alien-relative-i130-preparation-service/">
                        Family Green Card (I-130)
                      </a>
                    </li>
                    <li>
                      <a href="https://www.immigrationdirect.com/remove-conditions-residence-form-i-751/">
                        Remove Conditions (I-751)
                      </a>
                    </li>
                    <li>
                      <a href="https://www.immigrationdirect.com/adjustment-of-status-i485-preparation-service/">
                        Adjust Status (I-485)
                      </a>
                    </li>
                    <li>
                      <a href="https://app.immigrationdirect.com/green-card-expiration-reminder-service/">
                        Green Card Expiration Service
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Other Forms */}
              <div className="nav-item">
                <a href="https://www.immigrationdirect.com/uscis-forms-directory/">
                  Other Forms
                </a>
                <div className="menu-row">
                  <ul>
                    <li>
                      <a href="https://www.immigrationdirect.com/i-765-employment-authorization-application/">
                        EAD (Form I-765)
                      </a>
                    </li>
                    <li>
                      <a href="https://www.immigrationdirect.com/apply-deferred-action-daca-form-i-821d/">
                        DACA (I-821D)
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Resources */}
              <div className="nav-item">
                <a href="#">Resources</a>
                <div className="menu-row">
                  <ul>
                    <li>
                      <a href="https://app.immigrationdirect.com/case-status/">
                        USCIS Case Status
                      </a>
                    </li>
                    <li>
                      <a href="https://www.immigrationdirect.com/b1-business-visa-overview/">
                        B1 Business Visa eBook
                      </a>
                    </li>
                    <li>
                      <a href="https://www.immigrationdirect.com/b2-tourist-visa-overview/">
                        B2 Tourist Visa eBook
                      </a>
                    </li>
                    <li>
                      <a href="https://www.immigrationdirect.com/blog/uscis-processing-times-explained/">
                        USCIS Processing Times
                      </a>
                    </li>
                    <li>
                      <a href="https://www.immigrationdirect.com/blog/monthly-visa-bulletin-guide/">
                        Visa Bulletin
                      </a>
                    </li>
                    <li>
                      <a href="https://www.immigrationdirect.com/blog/">Blog</a>
                    </li>
                    <li>
                      <a href="https://www.immigrationdirect.com/news/">News</a>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Guides */}
              <div className="nav-item">
                <a href="https://www.immigrationdirect.com/guides/">Guides</a>
                <div className="menu-row">
                  <ul>
                    <li>
                      <a href="https://www.immigrationdirect.com/blog/how-to-apply-for-us-citizenship/">
                        Applying for U.S. Citizenship
                      </a>
                    </li>
                    <li>
                      <a href="https://www.immigrationdirect.com/guides/green-card-guide/">
                        Green Card Guide
                      </a>
                    </li>
                    <li>
                      <a href="https://www.immigrationdirect.com/us-visa-application-guides/">
                        Getting a U.S. Visa
                      </a>
                    </li>
                    <li>
                      <a href="https://www.immigrationdirect.com/blog/guidance-on-working-in-the-us/">
                        Working in the U.S.
                      </a>
                    </li>
                    <li>
                      <a href="https://www.immigrationdirect.com/guides/green-card-renewal-explained/">
                        Green Card Renewal
                      </a>
                    </li>
                    <li>
                      <a href="https://www.immigrationdirect.com/guides/form-n-400-naturalization/">
                        Naturalization Guide
                      </a>
                    </li>
                    <li>
                      <a href="https://www.immigrationdirect.com/blog/us-citizenship-test-overview/">
                        Citizenship Test
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              {/* About Us */}
              <div className="nav-item">
                <a href="https://www.immigrationdirect.com/about/">About Us</a>
                <div className="menu-row">
                  <ul>
                    <li>
                      <a href="https://www.immigrationdirect.com/immigration-lawyer-consultation/">
                        Lawyer Consultation
                      </a>
                    </li>
                    <li>
                      <a href="https://www.immigrationdirect.com/contact-us/">
                        Contact
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Single Links */}
              <div className="nav-item">
                <a href="https://www.immigrationdirect.com/immigration-virtual-assistant/">
                  Immigration Questions
                </a>
              </div>
            </div>
          </nav>

          <div>
            <Reminder
              termsUrl="https://www.immigrationdirect.com/terms-and-conditions/"
              privacyUrl="https://www.immigrationdirect.com/privacy-policy/"
            />
          </div>

          <footer class="site-footer footer-nav-bg">
            <div class="site-footer-container">
              <div class="footer-nav">
                <div class="footer-nav-logo">
                  <img
                    src="/assets-static/images/logo-en.png"
                    alt="Immigration Direct"
                    title="Immigration Direct"
                  />
                </div>
                <div class="footer-nav-links">
                  <p>
                    <a
                      href="https://www.immigrationdirect.com/contact-us/"
                      target="_blank"
                    >
                      Contact
                    </a>
                    <a
                      href="https://www.immigrationdirect.com/privacy-policy/"
                      target="_blank"
                    >
                      Privacy Policy
                    </a>
                    <a
                      href="https://www.immigrationdirect.com/terms-and-conditions/"
                      target="_blank"
                    >
                      Terms of Use
                    </a>
                    <a
                      href="https://www.immigrationdirect.com/terms-and-conditions/#refund"
                      target="_blank"
                    >
                      Refund Policy
                    </a>
                    <a
                      href="https://www.immigrationdirect.com/blog/"
                      target="_blank"
                    >
                      Blog
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </footer>

          <footer class="site-footer">
            <div class="site-footer-container">
              <div class="footer-disclaimer">
                <div class="footer-txt">
                  <p>
                    We are not a law firm, and this site and our software are
                    not a substitute for the advice of a lawyer and do not
                    contain or constitute legal advice. We are not affiliated
                    with or sponsored by the United States government or any
                    government agency. This site provides general information on
                    some commonly encountered immigration matters only and was
                    created to allow you to more simply navigate your completion
                    of immigration paperwork using online software. The content
                    on this site should not be relied on to reach conclusions
                    about any person's specific situation. Self-help software
                    and customer support services are provided solely at a
                    user's direction. Customer support is for technical and
                    billing issues only and will not answer legal questions. We
                    do not provide legal advice, opinions, or recommendations
                    about any individual's specific legal rights, remedies,
                    defenses, options, or strategies. We do not make form
                    recommendations or recommend or provide answers to specific
                    questions on forms, and communications between you and us
                    are not protected by any privilege. Purchase prices do not
                    include applicable government agency filing or biometrics
                    fees, if any. The forms that can be completed using our
                    software can be obtained for free from the U.S. Citizenship
                    and Immigration Services (USCIS) as blank forms with written
                    instructions. Automated eligibility quizzes were created
                    using instructions, rules and regulations published by the
                    USCIS and only indicate whether you meet minimum eligibility
                    requirements to apply for the given immigration benefit.
                    Quiz results do not guarantee eligibility or ineligibility
                    as you may or may not be eligible based on reasons not
                    addressed in the quizzes. Your access to and use of this
                    site, including any purchase, is subject to and constitutes
                    your agreement to the website{" "}
                    <a
                      href="https://www.immigrationdirect.com/privacy-policy/"
                      target="_blank"
                    >
                      Privacy Policy
                    </a>{" "}
                    and{" "}
                    <a
                      href="https://www.immigrationdirect.com/terms-and-conditions/"
                      target="_blank"
                    >
                      Terms of Use
                    </a>{" "}
                    Refunds will only be issued if requested within thirty (30)
                    days and before completed application is printed. Exceptions
                    and restrictions may apply; see{" "}
                    <a
                      href="https://www.immigrationdirect.com/terms-and-conditions/#refund"
                      target="_blank"
                    >
                      Refund Policy
                    </a>{" "}
                    for details.
                  </p>
                </div>
                <div class="footer-copyright">
                  <p>
                    Copyright © 2007-{new Date().getFullYear()}. All Rights
                    Reserved.
                  </p>
                </div>
              </div>
            </div>
          </footer>

          <a class="back-to-top" style={{ bottom: "8px" }}>
            <span></span>
            <p>Goto Top</p>
          </a>
        </div>
        <span className="back-to-top"></span>
        <Sidebar />
      </div>
    );
  }
}

export default App;
